import Vue from 'vue'
import Vuex from 'vuex'
import util from '@/libs/util'

Vue.use(Vuex)

let key = '_gConfig'

const store = new Vuex.Store({
  state: {
    gConfig: {}
  },
  mutations: {
    setGConfig (state, data) {
      if (data) {
        console.log('data', data)
        state.gConfig = data
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, JSON.stringify(data))
        }
      }
    },
    clearGConfig (state)   {
      state.gConfig = {}
      sessionStorage.setItem(key, JSON.stringify(state.gConfig))
    }
  },
  actions: {
    getSiteInfo (context, token) {
      if (!token) {
        key = sessionStorage.getItem('kzp_key')
      } else {
        key = token + key
        sessionStorage.setItem('kzp_key', key)
      }
      if (sessionStorage.getItem(key)) {
        context.commit('setGConfig', JSON.parse(sessionStorage.getItem(key)))
      } else {
        if (!token) {
          token = 'changsha_kzp_01'
          key = token + key
          sessionStorage.setItem('kzp_key', key)
        }
        return new Promise((resolve) => {
          util.get('index.php?r=kzp/config', {token: token}).then((result) => {
            context.commit('setGConfig', result.data)
            resolve()
          })
        })
      }
    },
    clearGConfig: ({commit}) => commit('clearGConfig')
  }
})

// no transitoin in demo site
const shouldUseTransition = !/transition=none/.test(location.href)

store.registerModule('vux', {
  state: {
    direction: shouldUseTransition ? 'forward' : ''
  },
  mutations: {
    updateDirection (state, payload) {
      if (!shouldUseTransition) {
        return
      }
      state.direction = payload.direction
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js